import { useNavigate } from 'react-router-dom';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import {
    PQRWEB_CREATE,
    PQRWEB_SEARCH,
    PQRWEB_SURVEY,
} from '../../../../../routes/paths';

export const PqrWebActions = () => {
    const navigate = useNavigate();

    return (
        <>
            <LoadingButtonGeneral
                variant="contained"
                title="Radicar"
                sx={{
                    mr: 1,
                    backgroundColor: 'primary.contrastText',
                }}
                onClick={() => navigate(PQRWEB_CREATE)}
                textSx={{ color: 'primary.main' }}
            />
            <LoadingButtonGeneral
                variant="contained"
                title="Consulta"
                sx={{
                    mr: 1,
                    backgroundColor: 'primary.contrastText',
                }}
                onClick={() => navigate(PQRWEB_SEARCH)}
                textSx={{ color: 'primary.main' }}
            />
            <LoadingButtonGeneral
                variant="contained"
                title="Encuesta"
                sx={{
                    mr: 1,
                    backgroundColor: 'primary.contrastText',
                }}
                onClick={() => navigate(PQRWEB_SURVEY)}
                textSx={{ color: 'primary.main' }}
            />
        </>
    );
};
